import React, { useState, createContext } from 'react'

export const JurisdictionContext = createContext()

export const JurisdictionProvider = (props) => {
	const [inputForm, setInputForm] = useState({
		initialJurisdiction: '',
		gasbJurisdiction: '',
		gaapJurisdiction: '',
	})

	const [jurisdiction, setJurisdiction] = useState('')

	return (
		<JurisdictionContext.Provider
			value={{ inputForm, setInputForm, jurisdiction, setJurisdiction }}
		>
			{props.children}
		</JurisdictionContext.Provider>
	)
}
